/**
 *  SASS/SCSS
 */

require('../sass/app.scss');


/**
 *  JS
 */

// Mooie requires hier...
// Outgoing links... invoke directly
require('./outgoinglinks.js')();
require('./login.js');
require('./behandelaars-popup.js')();
require('./search-publications.js');
require('./filter-archive.js');
require('./slider.js');
require('./onpage-search.js')();
require('./main.js');
require('./nav.js');
require('./forms.js');
require('./pre-footer.js');
require('./search-account-managers.js');
require('./cookie-bar.js');
// require('./article-handler.js'); TODO: Piwik
require('./table.js');
require('./video.js');
